<div>
  <mic-breadcrumb id="customer-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/customers" label="{{ translationService.translate('customersText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title mt-3" id="customer-heading">{{ translationService.translate('customersText') }}</h2>

  <form [formGroup]="form">
    <mat-card class="search-card custom-card-no-shadow mt-3">
      <div class="w-full flex flex-row items-center justify-between">
        <div class="filter-button-wrapper">
          <div class="responsive-filters">
            <mat-form-field id="search-field" subscriptSizing="dynamic">
              <button id="search-icon" mat-icon-button matPrefix>
                <mat-icon>search</mat-icon>
              </button>
              @if (search.value) {
              <button id="clear-icon" (click)="clearSearch()" mat-icon-button matSuffix>
                <mat-icon>close</mat-icon>
              </button>
              }
              <input
                matInput
                type="text"
                formControlName="searchString"
                autocomplete="off"
                placeholder="{{ translationService.translate('searchCustomerPlaceHolderText') }}"
              />
            </mat-form-field>

            <mat-form-field class="filter-field" id="type-filter" subscriptSizing="dynamic">
              <mat-label>{{ translationService.translate('searchTypeLabelText') }}</mat-label>
              <mat-select formControlName="customerType" placeholder="{{ translationService.translate('searchTypePlaceholderText') }}">
                @for (type of customerTypes; track type) {
                <mat-option [value]="type.key">{{ type.value }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="filter-field" id="status-filter" subscriptSizing="dynamic">
              <mat-label>{{ translationService.translate('searchByStatusText') }}</mat-label>
              <mat-select formControlName="status" placeholder="{{ translationService.translate('enterStatusPlaceHolderText') }}">
                <mat-option value="Y">{{ translationService.translate('activeText') }}</mat-option>
                <mat-option value="N">{{ translationService.translate('inactiveText') }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="filter-field" id="btm-flag-filter" subscriptSizing="dynamic">
              <mat-label>{{ translationService.translate('searchByBTMFlagText') }}</mat-label>
              <mat-select formControlName="btmFlag" placeholder="{{ translationService.translate('enterBTMFlagPlaceHolderText') }}">
                <mat-option value="Y">{{ translationService.translate('yesText') }}</mat-option>
                <mat-option value="N">{{ translationService.translate('noText') }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="button-container">
            <button id="reset-filters" type="button" mat-flat-button color="accent" (click)="resetFilters()">
              <mat-icon>refresh</mat-icon> {{ translationService.translate('clearSelectionText') }}
            </button>
            @if (canSyncLabel) {
            <button id="sync-labels" type="button" mat-flat-button color="primary" (click)="syncLabels()">
              {{ translationService.translate('syncLabelsButtonText') }}
            </button>
            }
            <span [matTooltip]="!isCustomerSelected ? translationService.translate('selectCustomersText') : ''" matTooltipPosition="below">
              <button id="assign-button" mat-flat-button color="primary" [disabled]="!isCustomerSelected" (click)="showAssignPlantModel()">
                {{ translationService.translate('assignToPlantText') }}
              </button>
            </span>
            <button id="add-button" type="button" mat-flat-button color="primary" (click)="createCustomer()">
              <mat-icon>add</mat-icon> {{ translationService.translate('addText') }}
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  </form>

  <div id="customer-info-table" class="cam-table mt-2">
    <div class="table-wrapper">
      <mic-table appCopyOnSelect #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher" [filtersConfig]="">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'typeCell'">
          <div class="flex flex-row gap-2">
            @switch (item.customerType) { @case ('Customer') {
            {{ translationService.translate('customerText') }}
            } @case ('AssociateDealer') {
            {{ translationService.translate('associateDealerText') }}
            } @case ('AssociateCustomer') {
            {{ translationService.translate('associateDealerCustomerText') }}
            } @case ('DefaultCustomer') {
            {{ translationService.translate('defaultCustomerText') }}
            } @case ('MichelinCustomer') {
            {{ translationService.translate('michelinCustomerText') }}
            } }
          </div>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'activeCell'">
          <div class="flex flex-row gap-2">
            @if (item.active === 'Y') {
            <mic-status class="valid">{{ translationService.translate('activeText') }}</mic-status>
            } @if (item.active === 'N') {
            <mic-status>{{ translationService.translate('inactiveText') }}</mic-status>
            }
          </div>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'plantCell'">
          <div class="flex flex-row gap-2">
            @if (!item.plantCodes || item.plantCodes.length === 0) {
            <div>No Plants (Inactive)</div>
            } @if (item.plantCodes && item.plantCodes.length > 0) {
            <div matTooltipClass="big-tooltip" matTooltip="{{ item.plantCodes.join(', ') }}" aria-label="item.plantCodes">
              {{
                item.plantCodes.length > 1
                  ? item.plantCodes.join(', ').length > 15
                    ? item.plantCodes.join(', ').substring(0, 15) + '...'
                    : item.plantCodes.join(', ')
                  : item.plantCodes[0]
              }}
            </div>
            }
          </div>
        </ng-container>

        <ng-container *micTableColumnSelector>
          <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
            <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
          </button>
          <mat-menu #colMenu="matMenu">
            <div style="padding: 8px 16px; max-width: 320px">
              <div *ngFor="let key of columnKeys">
                <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">{{
                  columnNames[key] || key
                }}</mat-checkbox>
              </div>
            </div>
          </mat-menu>
        </ng-container>
      </mic-table>
    </div>

    <mic-modal class="modalC" #viewAssignplant style="height: 30%"></mic-modal>
    <ng-template #assignedtoplants>
      <div class="table-wrapper">
        <mic-table id="plant-table" class="table-stripped" [config]="tableConfig2" [fetcher]="plantTableFetcher" [filtersConfig]="">
          <ng-container *micTableNoData>
            <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
          </ng-container>
        </mic-table>
      </div>

      <div class="modal-action-row">
        <button id="cancel-button" mat-stroked-button color="primary" (click)="showUnsavedAssignPlantsChangesModal()">
          <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelLinkText') }}
        </button>
        <button id="apply-button" mat-flat-button color="primary" [disabled]="!isPlantAssigned" (click)="showConfirmChangeModal()">
          <mat-icon>check</mat-icon> {{ translationService.translate('applyText') }}
        </button>
      </div>
    </ng-template>

    <ng-container *micTableNoData>
      <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
    </ng-container>

    <mic-modal class="modalC" #confirmation id="plant-confirmation" (result)="onAssignPlantConfirmationModalClosed($event)"></mic-modal>
    <ng-template #confirmationContent>
      {{ translationService.translate('plantAssignmentConfirmationText') }}
    </ng-template>
    <mic-modal
      class="modalC"
      #cancelConfirmation
      id="cancel-plantchanges"
      (result)="onUnsavedAssignPlantsChangesModalClosed($event)"
    ></mic-modal>
    <ng-template #cancelConfirmationContent> {{ translationService.translate('unSaveChangesText') }}</ng-template>
  </div>
</div>
